import React from 'react';

import Typography from 'components/typography/typography';

import { LegaliseDiplomaDUOUrl } from 'constants/signup-flow-constants';

const Diplomas2008Instructions: React.FC = () => {
  return (
    <div className="w-full flex flex-col">
      <Typography as="p" variant="body-medium" className="text-gray600">
        Omdat je je diploma voor 2007 hebt behaald, kan je deze niet downloaden
        bij DUO. Er zijn verschillende opties om hiermee om te gaan.
        <br />
      </Typography>
      <Typography as="p" variant="body-large-bold" className="text-gray600">
        Contact opnemen met je onderwijsinstelling
        <br />
      </Typography>

      <Typography as="p" variant="body-medium" className="text-gray600 mt-2">
        Neem contact op met de onderwijsinstelling waar je je diploma hebt
        behaald. Neem een kopie mee van je diploma, en vraag bij de
        onderwijsinstelling om deze te voorzien van een stempel, datum en
        handtekening.
        <br />
        <br />
        Upload vervolgens je originele diploma en de kopie met de handtekening
        en stempel erop van de onderwijsinstelling in pdf.
      </Typography>
      <Typography
        as="p"
        variant="body-large-bold"
        className="text-gray600 mt-2"
      >
        Kun jij niet terecht bij de onderwijsinstelling?
        <br />
      </Typography>

      <div className="text-gray600 mt-2">
        <Typography as="p" variant="body-medium">
          Je hebt dan twee opties:
          <br />
          <br />
          1. Neem contact op met het SBB. Het SBB geeft verklaringen af over de
          waarde van een verouderd diploma. In deze verklaring staat vermeld met
          welk niveau binnen de huidige kwalificatiestructuur een opleiding
          vergelijkbaar is. Upload vervolgens je originele diploma en de
          verklaring van het SBB in pdf..
          <br />
          <br />
          2. Legaliseer je diploma bij DUO. Dit kan in Rotterdam of Groningen.
          Hiervoor kan je een afspraak maken op de{' '}
          <a href={LegaliseDiplomaDUOUrl} className="font-bold text-purple">
            website van DUO
          </a>
          . Upload vervolgens het originele diploma en het gewaarmerkte diploma
          in pdf.
        </Typography>
      </div>
    </div>
  );
};

export default Diplomas2008Instructions;
